import { updateCartBuyerIdentity, updateCustomerCartBuyerIdentity } from '@/hooks/shopify-hooks/api/useLoginApi';
import { useQueryCart } from '@/hooks/shopify-hooks/useManageCart';
import { _CSR_SHOP_CART_ID, _CSR_TOKEN_REFRESHTOKEN , _CSR_IS_B2b, _CSR_ID_TOKEN, _CSP_STORENFONT_TOKEN, _CSR_COMPANY_LOCATION, _CSR_ACCESS_TOKEN, _CSR_LOGIN_EMAIL, _CSR_B2B_TOKEN_CALLBACK_URL, _CSR_USER_NAME } from '@/const/shopifyConst';
import { QueryParam, parseParams } from '@/utils/common';
import { attemptObtainAccessToken, attemptAccessTokenExchange, useCustomerTokenApi, useCustomerQueryApi, useIsAccessTokenValid } from '@/hooks/shopify-hooks/useShopifyUtils';
import { useDeleteCustomerAccessToken } from '@/hooks/shopify-hooks/api/useLoginApi'; 
import { shopifyConst,isEnableShopify } from '@/hooks/shopify-hooks/useShopifyConst.js';
import { useCustomer } from "@/hooks/shopify-hooks/useCustomer";
import { useSetStorage, useGetStorage, useRemoveStorage, useSetSessionStorage, useGetSessionStorage, useRemoveSessionStorage } from '@/hooks/common/useStorage';
import { generateState, generateCodeVerifier, generateCodeChallenge } from '@/utils/codeUtils.js';
import { useFormV3Loading } from "@/hooks/form-v3/useFormV3Loading";
import {  useBrand } from "@/hooks/common/useUtils";
const brand = useBrand();
const { storeId ,c4aOAuth2State} = shopifyConst;
const c4aOAuth2StateNew = c4aOAuth2State === 'true' ? true : false;
let cartId = useGetStorage(_CSR_SHOP_CART_ID);
const { showLoading, hideLoading } = useFormV3Loading();

// const hasHtpp = (url) =>{
//   // 检查是否以 http:// 或 https:// 开头
//   const isAbsolute = /^https?:\/\//i.test(url);
  
//   // 自带域名 → 直接返回；不带 → 拼接 origin
//   return isAbsolute ? url : `${window.location.origin}${url}`;
// }

// 获取页面跳转地址，从header组件配置中获取
export const useGetPath = () => {
  let className = 'mdws-header';
  if(brand === 'toshiba'){
    className = 'tsws-header-v1'
  }
  const header = document.querySelector(`.${className}`);
  const data = window?.__AEM_CONF__?.components?.[header?.id] || {};
  const { homePagePath, loginPath, myAccountPath, loginPathForMobile } = data || {};
  return {
    homePagePath: homePagePath?window.location.origin + decodeURIComponent(homePagePath):'',
    loginPath: decodeURIComponent(loginPath),
    myAccountPath: window.location.origin + decodeURIComponent(myAccountPath),
    loginPathForMobile: loginPathForMobile
    
  }
  
}

export const useCartQuantity = async (quantity) => {
  cartId = useGetStorage(_CSR_SHOP_CART_ID);
  let cartQuantity = quantity;
  if (!cartQuantity && isEnableShopify) {
    if (cartId) {
      const res = await useQueryCart(cartId);
      console.log('res: ', res);
      cartQuantity = res?.cart?.totalQuantity || 0;
    } else {
      cartQuantity = 0;
    }
  } 
  // 发放事件，传递购物车数量
  window?.observer?.dispatch("cart-quantity-js-loaded", cartQuantity);
}

export const useCartQuantitySubscribe = () => {
  window?.observer?.subscribe("cart-quantity-update-loaded", () => {
    useCartQuantity();
  });
}

// 退出登录
export const useLogOut = async () => {
  const { homePagePath } = useGetPath();
  console.log('--退出登录', homePagePath);

  const accessToken = useGetStorage(_CSR_ACCESS_TOKEN);
  const id = useGetStorage(_CSR_ID_TOKEN);
  const isB2B = id ? true : false;
  console.log('新C4A',`https://shopify.com/authentication/${storeId}/logout` + "?id_token_hint=" + encodeURIComponent(id) + "&post_logout_redirect_uri=" + encodeURIComponent(homePagePath))
  // 有购物车id, 先删除购物车购买者身份，再退出登录
  if (cartId) {
    await useDeleteCartBuyerIdentity(isB2B);
  }

  useRemoveStorage(_CSR_ACCESS_TOKEN);
  useRemoveStorage(_CSR_IS_B2b);
  useRemoveStorage(_CSP_STORENFONT_TOKEN);
  useRemoveStorage(_CSR_COMPANY_LOCATION);
  useRemoveStorage(_CSR_LOGIN_EMAIL);
  useRemoveStorage(_CSR_USER_NAME);

  if (id) {
    useRemoveStorage(_CSR_ID_TOKEN);
    // 告知igws-header组件，退出登录
    window?.observer?.dispatch("b2b-logout-js-loaded");
    // B2B退出登录需要跳转shopify退出链接, shopify那边才是真正做退出登录的逻辑
    // 参数值都要encodeURIComponent一下，不然shopify那边校验不对
    window.location.href = `https://shopify.com/authentication/${storeId}/logout` + "?id_token_hint=" + encodeURIComponent(id) + "&post_logout_redirect_uri=" + encodeURIComponent(homePagePath);
  } else {
    // 调用shopify接口删除accessToken
    await useDeleteCustomerAccessToken(accessToken.accessToken);
    window.location.href = homePagePath;
  }
}
// eslint-disable-next-line complexity
export const useUpdataCartBuyerIdentity = async (accessToken) => {
  const id = c4aOAuth2StateNew? c4aOAuth2StateNew : useGetStorage(_CSR_IS_B2b);
  const isB2B = id ? true : false;
  if (isB2B) {
    let storefrontToken = useGetStorage(_CSP_STORENFONT_TOKEN);
    if (!storefrontToken || storefrontToken === 'undefined') {
      // 首次登录，需要获取storefront token
      const storefrontTokenResponse = await useCustomerTokenApi(accessToken.accessToken);
      storefrontToken = storefrontTokenResponse?.data?.storefrontCustomerAccessTokenCreate?.customerAccessToken;
      useSetStorage(_CSP_STORENFONT_TOKEN, storefrontToken);
    }
   
    let locationId = useGetStorage(_CSR_COMPANY_LOCATION);
    if (!locationId) {
      // 首次登录，需要获取顾客的公司地址
      const response = await useCustomerQueryApi(accessToken.accessToken);
      const customerResponse = response?.data?.customer;
     
      
      console.log('顾客查询', response)
      // 判断是否有公司地址，是的话就默认选择第一个地址，若无地址，不算真正的b端用户，商品没有b端折扣的权限
      if (customerResponse?.companyContacts?.edges?.length && customerResponse?.companyContacts?.edges?.[0]?.node?.company?.locations?.edges?.length > 0) {
        useSetStorage(_CSR_COMPANY_LOCATION, customerResponse?.companyContacts?.edges?.[0]?.node?.company?.locations?.edges?.[0]?.node?.id);
        locationId = customerResponse?.companyContacts?.edges?.[0]?.node?.company?.locations?.edges?.[0]?.node?.id;
      }
      if (!c4aOAuth2StateNew) {
        // 更新顾客名称，告知header组件更新
        console.log('===csr===身份更新', useGetStorage(_CSR_COMPANY_LOCATION));
        useCustomerName(customerResponse);
      }
    }
    // 若没有购物车，则不走购物车购买者身份更新操作
    if (!cartId) {
      return;
    }
    
    const b2bBuyerIdentity = {
      customerAccessToken: storefrontToken,
      companyLocationId: locationId,
    };
    await updateCartBuyerIdentity(b2bBuyerIdentity, cartId);
  
  }
}

export const useCartBuyerIdentity = async () => {
  // 监听购物车购买者身份加载完成事件，执行购物车购买者身份更新操作，一般是b2b登录后触发
  window?.observer?.subscribe("cart-buyer-identity-js-loaded", () => {
    useInitB2bCallback();
  })
}

export const useCustomerName = async (customerInfo) => {
  const ownB2BTag = useGetStorage(_CSR_IS_B2b) && useGetStorage(_CSR_COMPANY_LOCATION) ? true : false;
  if (customerInfo) {
    const {displayName:name,lastName=''} = customerInfo
    useSetStorage(_CSR_USER_NAME, name);
    window?.observer?.dispatch("customer-name-js-loaded", { name, ownB2BTag,lastName });
  } else if (useIsAccessTokenValid()  && isEnableShopify) {
    const { getCustomer } = useCustomer();
    const customer = await getCustomer();
    if (!customer) {
      await useDeleteLoginStorage();
      return;
    }
    const {displayName:name='',lastName=''} = customer
    // const name = customer?.displayName;
    window?.observer?.dispatch("customer-name-js-loaded", { name,lastName, ownB2BTag });
    useSetStorage(_CSR_USER_NAME, name);
  }
}

// 登录后个人弹窗首次渲染有动画时间误差，所以用事件监听模式更改
export const useCustomerNameUpdate = () => {
  window?.observer?.subscribe("update-customer-name-load", async () => {
    await useCustomerName();
  });
}

// b2b登录回调
export const useInitB2bCallback = async () => {
  const params = QueryParam.parse(window.location.search);
  const codeParam = params.code;
  if (codeParam) {
    showLoading();
    // 根据code换取access_token，调用的是shopify的接口
    const accessTokenResp = await attemptObtainAccessToken(codeParam);
    console.log('--执行token1返回', accessTokenResp)
    if (accessTokenResp && accessTokenResp.access_token) {
      if (accessTokenResp.id_token) {
        // 退出登录的时候，id_token需要用到
        useSetStorage(_CSR_ID_TOKEN, accessTokenResp.id_token);
      }
      useSetStorage(_CSR_TOKEN_REFRESHTOKEN, accessTokenResp.refresh_token);
      console.log('--执行token2')
      const exchangeTokenResp = await attemptAccessTokenExchange(accessTokenResp.access_token);
      if (exchangeTokenResp && exchangeTokenResp.access_token) {
        const finalToken = {
          accessToken: exchangeTokenResp.access_token,
          expiresAt: exchangeTokenResp.expires_in
        };
        useSetStorage(_CSR_ACCESS_TOKEN, finalToken);
        if(!c4aOAuth2StateNew){
          useSetStorage(_CSR_IS_B2b, true);
          // 更新用户身份
        }
        await useUpdataCartBuyerIdentity(finalToken);
      }
      
      const callbackUrl = useGetSessionStorage(_CSR_B2B_TOKEN_CALLBACK_URL);
      console.log('==记录sessionStorage==', callbackUrl)
      if (callbackUrl) {
        // 删除回调地址
        useRemoveSessionStorage(_CSR_B2B_TOKEN_CALLBACK_URL);
        hideLoading();
        window.location.href = callbackUrl;
      } else {
        const url = location.search;
        const urlParams = new URLSearchParams(url);
        // 移除code参数
        urlParams.delete('code');
        // 获取处理后的查询字符串
        const newQueryString = urlParams.toString();
        const newUrl = newQueryString ? location.pathname + '?' + newQueryString : location.pathname;
        // 重新加载当前页面，刷新商品价格
        hideLoading();
        location.replace(newUrl);
      }
    }
  }
}

// 删除购物车购买者身份
export const useDeleteCartBuyerIdentity = async (isB2B) => {
  if (isB2B) {
    const b2bBuyerIdentity = {
      customerAccessToken: null,
      companyLocationId: null,
    };
    await updateCartBuyerIdentity(b2bBuyerIdentity, cartId);
  } else {
    const buyerIdentity = {
      customerAccessToken: null,
      email: null
    }
    await updateCustomerCartBuyerIdentity(buyerIdentity, cartId);
  }
}

// 获取用户信息失败，删除用户相关的localStorage(这种情况出现在多个人共用一个账号，其中一个人退出登录，另一个还在使用)
export const useDeleteLoginStorage = async (jumpLogin) => {
  useRemoveStorage(_CSR_ACCESS_TOKEN);
  useRemoveStorage(_CSR_IS_B2b);
  useRemoveStorage(_CSP_STORENFONT_TOKEN);
  useRemoveStorage(_CSR_COMPANY_LOCATION);
  useRemoveStorage(_CSR_ID_TOKEN);
  useRemoveStorage(_CSR_LOGIN_EMAIL);
  useRemoveStorage(_CSR_USER_NAME);

  if (cartId) {
    await useDeleteCartBuyerIdentity(false);
  }
  if (jumpLogin) {
    const { homePagePath } = useGetPath();
    window.location.href = homePagePath;
  }
}
// 跳转b2b登录页, 第一个参数是是否在当前页面跳转，第二个参数是是否需要回调到前一个页面
export const useGetB2bLoginURL = async (target = '_self', needCallBack) => {
  const { clientId, storeId, customerRedirectUrl, languageIsoCode  } = shopifyConst;
  const url = `https://shopify.com/${storeId}/auth/oauth/authorize`
  const state = await generateState();
  const verifier = await generateCodeVerifier();
  const challenge = await generateCodeChallenge(verifier);
  // customerRedirectUrl没有配置域名，组装完整redirect_uri
  let redirect_uri = window.location.protocol + '//' + window.location.host + customerRedirectUrl;
  if(c4aOAuth2StateNew){
    const { homePagePath } = useGetPath();
    redirect_uri =  homePagePath
  }
  useSetStorage('state', verifier);
  useSetStorage('code-verifier', verifier);
  const params = {
    scope: 'openid email https://api.customers.com/auth/customer.graphql',
    client_id: clientId,
    response_type: 'code',
    redirect_uri: redirect_uri,
    code_challenge_method: 'S256',
    state,
    code_challenge: challenge,
    locale: languageIsoCode
  }
  // token失效，需要回调到当前页面，记录当前页面地址
  if (needCallBack) {
    useSetSessionStorage(_CSR_B2B_TOKEN_CALLBACK_URL, window.location.href);
    console.log('==存储sessionStorage==', window.location.href);
  }
  const b2bLoginUrl = parseParams(url, params);
  console.log('---b2bLoginUrl', b2bLoginUrl)
  window.open(b2bLoginUrl, target);  
}

